import api from "../../services/baseapi";

export type AuditLogItem = {
  id: string;
  user_full_name: string | null;
  created_at: string;
  modified_at: string | null;
  action: string;
  tool?: string | null;
  tool_label?: string | null;
  data_name?: string | null;
};

export type AuditLogsResponse = {
  total: number;
  page: number;
  page_size: number;
  items: AuditLogItem[];
};

export type GetAuditLogsParams = {
  project_id: string;
  filter?: string;
  date_created?: string;
  date_modified?: string;
  tool?: string;
  data_name?: string;
  user_name?: string;
  page?: number;
  page_size?: number;
};

export type ToolOption = {
  value: string;
  label: string;
};

export type ToolsResponse = {
  items: ToolOption[];
};

export const getAuditLogs = async (
  params: GetAuditLogsParams,
): Promise<AuditLogsResponse> => {
  const query: Record<string, any> = {
    project_id: params.project_id,
    page: params.page ?? 1,
    page_size: params.page_size ?? 20,
  };

  if (params.filter) query.filter = params.filter;
  if (params.date_created) query.date_created = params.date_created;
  if (params.date_modified) query.date_modified = params.date_modified;
  if (params.tool) query.tool = params.tool;
  if (params.data_name) query.data_name = params.data_name;
  if (params.user_name) query.user_name = params.user_name;

  const { data } = await api.get<AuditLogsResponse>("/audit-logs", {
    params: query,
  });
  return data;
};

export const getAuditTools = async (): Promise<ToolsResponse> => {
  const { data } = await api.get<ToolsResponse>("/audit-logs/tools");
  return data;
};
